module.exports = __webpack_public_path__ + "img/TKL-white.346c95a5.png";